import styled, { keyframes } from "styled-components";
import {
  Icon,
  RowView,
  RowView2,
} from "../../../../Component/style/common_style";
import { useNavigate } from "react-router-dom";

interface handleSidebarToggleProps {
  handleSidebarToggle: () => void;
  isVisible: boolean;
}

const SideBar = ({
  handleSidebarToggle,
  isVisible,
}: handleSidebarToggleProps) => {
  const navigate = useNavigate();

  const goServiceCenter = () => {
    navigate("/help");
  };
  return (
    <SideBarDiv $isVisible={isVisible}>
      <TitleDiv>
        <div>메뉴</div>
        <Icon
          className="btn"
          style={{ width: 24 }}
          src={require("../../../../Image/ic_x_white.png")}
          onClick={handleSidebarToggle}
        />
      </TitleDiv>
      <MenuList>
        <RowView2 onClick={goServiceCenter} style={{ cursor: "pointer" }}>
          <Icon
            src={require("../../../../Image/ic_headset_white.png")}
            style={{ marginRight: 5 }}
          />
          고객센터
        </RowView2>
      </MenuList>
    </SideBarDiv>
  );
};
export default SideBar;

// 슬라이드 애니메이션 정의
const slideIn = keyframes`
  from {
    transform: translateX(100%); /* 화면 밖에서 시작 */
  }
  to {
    transform: translateX(0); /* 화면 안으로 이동 */
  }
`;

const slideOut = keyframes`
  from {
    transform: translateX(0); /* 화면 안에서 시작 */
  }
  to {
    transform: translateX(100%); /* 화면 밖으로 이동 */
  }
`;

const SideBarDiv = styled.div<{ $isVisible: boolean }>`
  width: 50%;
  height: 100%;
  top: 0;
  right: 0;
  box-sizing: border-box;
  background-color: #191919;
  position: absolute;
  z-index: 2;
  animation: ${({ $isVisible }) => ($isVisible ? slideIn : slideOut)} 0.3s
    ease-in-out;
  transform: ${({ $isVisible }) =>
    $isVisible ? "translateX(0)" : "translateX(100%)"};
`;

const TitleDiv = styled(RowView)`
  padding: 24px;
  font-family: var(--font-Pretendard-SemiBold);
  font-size: 18px;
`;

const MenuList = styled.div`
  padding: 12px 24px;
  font-family: var(--font-Pretendard-SemiBold);
  font-size: 16px;
`;
